import React from "react";
import {LockRounded} from "@mui/icons-material";

const Tab = props => {
    const {className, tab, disabled = false, activeTab, ...other} = props;

    return (
        <div className={'ch-tab' + (disabled ? ' ch-tab-disabled' : '') + (className ? ' ' + className : '')} {...other}>
            {tab}{disabled && <LockRounded style={{fontSize: 14, verticalAlign: 'middle'}} />}
        </div>
    )
}

export default Tab;